import { render, staticRenderFns } from "./recommProduct.vue?vue&type=template&id=3766d620&scoped=true"
import script from "./recommProduct.vue?vue&type=script&lang=js"
export * from "./recommProduct.vue?vue&type=script&lang=js"
import style0 from "./recommProduct.vue?vue&type=style&index=0&id=3766d620&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3766d620",
  null
  
)

export default component.exports